import React from 'react'
import { Container } from '@components/gassan-ui'
import { cn } from '@lib/cn'

type HeaderContainerProps = {
  variant?: 'rolex' | 'rcpo'
  children: React.ReactNode
}

const HeaderContainer: React.FC<HeaderContainerProps> = ({ children, variant = 'rolex' }) => (
  <div
    className={cn(
      'relative z-[3] flex h-20 items-center md:h-[100px] lg:h-[110px]',
      variant === 'rcpo' ? 'bg-black' : 'bg-gradient-to-r from-rolexGreenDark to-rolexPrimary',
    )}
  >
    <Container className="flex items-center justify-between">{children}</Container>
  </div>
)

export default HeaderContainer
